import React, { useState, useEffect, useRef } from "react";

// Tooltip Component for reuse
const Tooltip = ({ text, isVisible, setIsVisible }) => {
  // Track if we're on a touch device
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  // Ref for the tooltip container
  const tooltipRef = useRef(null);

  useEffect(() => {
    // Detect if it's a touch device
    const isTouchCapable =
      "ontouchstart" in window || window.navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0;
    setIsTouchDevice(isTouchCapable);

    // Add click outside listener
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target) && isVisible) {
        setIsVisible(false);
      }
    };

    // Add listener when tooltip is visible
    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isVisible, setIsVisible]);

  // Only use hover events on non-touch devices
  const hoverProps = !isTouchDevice
    ? {
        onMouseEnter: () => setIsVisible(true),
        onMouseLeave: () => setIsVisible(false),
      }
    : {};

  return (
    <div className="relative inline-block ml-1" ref={tooltipRef}>
      <button
        type="button"
        className="text-gray-500 hover:text-gray-700 focus:outline-none p-1"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation(); // Prevent event from reaching document
          // Toggle visibility on click
          setIsVisible(!isVisible);
        }}
        {...hoverProps}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {isVisible && (
        <div
          className="absolute left-0 md:left-auto md:right-0 bottom-full mb-2 w-[250px] md:w-[350px] bg-gray-800 text-white text-sm rounded-lg shadow-lg p-4 z-10"
          style={{ transform: "translateX(-50%)", left: "50%", maxWidth: "calc(100vw - 40px)" }}
        >
          <div className="relative">
            <p className="leading-relaxed">{text}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
